// Footer.js

import { Link } from "react-router-dom";
import { ROUTES } from "../Routes";

const EXTERNAL_LINKS = [
  {
    name: "Gambling Helpline Norway",
    url: "https://hjelpelinjen.no"
  },
  {
    name: "Responsible Gambling",
    url: "https://responsiblegambling.org"
  },
  {
    name: "Norway Ministry of Health",
    url: "https://www.regjeringen.no"
  },
];

const INTERNAL_LINKS = [
  {
    name: "About Us",
    path: ROUTES.ABOUT
  },
  {
    name: "Contact",
    path: ROUTES.CONTACT
  },
  {
    name: "Terms of Service",
    path: ROUTES.TERMS
  },
  {
    name: "Privacy Policy",
    path: ROUTES.PRIVACY
  },
  {
    name: "Responsible Gaming",
    path: ROUTES.RESPONSIBLE
  },
];

function Footer() {
  return (
    <footer>
      <div
        className="footer-links external-links"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {EXTERNAL_LINKS.map((link) => (
          <li key={link.name} style={{ listStyle: 'none' }}>
            <a
              className="footer-link"
              style={{ padding: '5px' }}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.name}
            </a>
          </li>
        ))}
      </div>

      <div className="footer-links internal-links">
        {INTERNAL_LINKS.map((link) => (
          <Link
            key={link.name}
            to={link.path}
          >
            {link.name}
          </Link>
        ))}
      </div>

      <div className="footer-text">
        <p>© 2025 polira.site - Entertainment Platform</p>
        <p>⚠️ No Real Money Involved | For Entertainment Only | 18+ ⚠️</p>
      </div>
    </footer>
  );
}

export default Footer;